<template>
  <div>
    <div v-if="adjustableParts">
      <label class="form-check-label ml-2">
        {{ item.label }} - {{ itemTotal | currency }}
      </label>
      <div class="px-4 mb-2">
        <div class="help-block well p-4 pt-1">
          <OrderItemPartComponent
            v-for="(part, index) in item.parts"
            :key="index"
            :part="part"
            :self-index="index"
            :parent-index="selfIndex"
            :adjustment-type="adjustmentType"
            @updateSelected="updateSelected"
            @partTotalUpdated="partTotalUpdated"
          ></OrderItemPartComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderItemPartComponent from "./OrderItemPartComponent.vue";

export default {
  components: {
    OrderItemPartComponent,
  },
  filters: {
    currency(amount) {
      return `$ ${amount.toFixed(2)}`;
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    adjustmentType: {
      type: String,
      required: true,
    },
    selfIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selectedItems: [],
      partTotals: [],
    };
  },
  computed: {
    adjustableParts() {
      return (
        this.item.parts.filter((e) => {
          return e.quantity[this.adjustmentType] > 0;
        }).length > 0
      );
    },
    itemTotal() {
      return this.partTotals.reduce((a, obj) => a + obj.total, 0);
    },
  },
  watch: {
    itemTotal() {
      return this.$emit("itemTotalUpdated", this.selfIndex, this.itemTotal);
    },
  },
  methods: {
    updateSelected(partIndex, isSelected) {
      if (isSelected) {
        this.selectedItems.push(partIndex);
      } else {
        this.selectedItems = this.selectedItems.filter((i) => i !== partIndex);
      }

      const bool = this.selectedItems.length > 0;

      return this.itemSelect(bool);
    },
    itemSelect(bool) {
      return this.$emit("itemSelect", this.selfIndex, bool);
    },
    partTotalUpdated(partIndex, total) {
      const index = this.partTotals.findIndex(
        (obj) => obj.partIndex === partIndex
      );
      if (index === -1) return this.partTotals.push({ partIndex, total });
      if (total === 0) return this.partTotals.splice(partIndex, 1);
      this.partTotals[index].total = total;
      return this.partTotals[index].total;
    },
  },
};
</script>
